export class Criteria {
	constructor(public userType?: string, public profileType?: string, public serviceTypes?: string[]) {}
}
